/* eslint-disable no-use-before-define */
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import NavItem from './item';

export default function ListNav({ pathname, isPathActive, navItems }) {
  const items = generateNavItems(navItems);
  return (
    <Div>
      {items.map(({ link, title, matchRegex, subPages }) => {
        let isActive = matchRegex ? matchRegex.test(pathname) : isPathActive(link);
        if (!isActive && subPages) {
          isActive = subPages.some(page => isPathActive(page.link));
        }

        return (
          <NavItem key={link} href={formatLink(link)} subPages={subPages} active={isActive}>
            {title}
          </NavItem>
        );
      })}
    </Div>
  );
}

ListNav.propTypes = {
  pathname: PropTypes.string.isRequired,
  isPathActive: PropTypes.func.isRequired,
  navItems: PropTypes.array.isRequired,
};

const Div = styled.nav`
  display: flex;
  align-self: stretch;
  @media screen and (max-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: none;
  }
`;

function formatLink(link) {
  const host = process.env.NODE_ENV === 'production' ? process.env.DOC_HOST || '' : '';
  return link.startsWith('/') ? `${host}${link}` : link;
}

export function generateSubPage([link, title]) {
  return {
    link,
    title,
  };
}

export function generateNavItems(config) {
  return config.map(({ link, title, matchRegex, subPages }) => ({
    title,
    link,
    matchRegex,
    subPages: subPages && Object.entries(subPages).map(generateSubPage),
  }));
}
